(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', 'JhiTrackerService'];

    function Principal ($q, Account, JhiTrackerService) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            getUserInstruments: getUserInstruments,
            isInUsers: isInUsers,
            isUser: isUser,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated) {
                return $q.when(false);
            }
            
            return this.identity().then(function(_id) {
                for (var i = 0; i < authorities.length; i++) {
                    if (_id.authorities && _id.authorities.indexOf(authorities[i]) !== -1) {
                        return true;
                    }
                }
            }, function(){
                return false;
            });
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function getUserInstruments () {
            if (!_authenticated) {
                return [];
            }
            return this.identity().then(function(_id) {
                return _id.instruments;
            }, function() {
                return [];
            });
        }

        function isUser (login) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.login && _id.login === login;
            }, function(){
                return false;
            });
        }

        function isInUsers (logins) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                for (var i = 0; i < logins.length; i++) {
                    if (_id.login && _id.login === logins[i]) {
                        return true;
                    }
                }
            }, function(){
                return false;
            });
        }
        
        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
                JhiTrackerService.connect();
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();
